var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.25H6C5.46957 2.25 4.96086 2.46071 4.58579 2.83579C4.21071 3.21086 4 3.71957 4 4.25V19.75C4 20.2804 4.21071 20.7891 4.58579 21.1642C4.96086 21.5393 5.46957 21.75 6 21.75H18C18.5304 21.75 19.0391 21.5393 19.4142 21.1642C19.7893 20.7891 20 20.2804 20 19.75V8.75L13.5 2.25Z",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 2.25V8.75H20",
    stroke: "#353535",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.cac92e5b77bb79bba48124b92f94474c.svg";
export { ForwardRef as ReactComponent };